import React from 'react';
import { Dashboards } from './dashboards/index.tsx';
import { IssueViewModal } from './issue-view-modal/index.tsx';
import { KeyboardShortcuts } from './keyboard-shortcuts/index.tsx';
import { Projects } from './projects/index.tsx';

export function Integrations() {
	if (!__SERVER__) {
		return (
			<>
				<IssueViewModal />
				<Projects />
				<Dashboards />
			</>
		);
	}
	return null;
}
Integrations.displayName = 'Integrations'; // This is needed to pass the test.tsx's uniqueness-test. Without it, the component appears as 'ComponentWithCondition[]', which already exists in the list.

export function IntegrationsWhichRequireNavigationRoot() {
	if (!__SERVER__) {
		return <KeyboardShortcuts />;
	}
	return null;
}
